/*!
 * reopen-by-hash
 * @version v1.0.4
 * @copyright Tussendoor internet & marketing
 */
(function() {
    var hash = window.location.hash.substring(1);
    if (!hash) return;
    console.log('hash found: ' + hash);

    var id = document.getElementById(hash);
    if (!id) return;
    console.log('element found: ' + id);

    accordionOpenerOnLoad(id);
})();

/*!
 * a11y-accordion-opener
 * @version v1.0.5
 * @copyright Tussendoor internet & marketing
 */
function accordionOpenerOnLoad (id) {
    var scrollto;
    id.classList.add('open');
    id.querySelector('.js--faq__trigger').setAttribute('aria-expanded', 'true');
    id.querySelector('.js--faq__inner').setAttribute('aria-hidden', 'false');

    function scrollDelay() {
      scrollto = setInterval(scrollToTop, 150);
    }

    function scrollToTop() {
      id.scrollIntoView();
      clearInterval(scrollto);
    }

    scrollDelay();
}

document.addEventListener('click', function (event) {
	if (!event.target.closest('.js--faq__trigger')) return;
    accordionControler(event);
});

/*!
 * a11y-accordion-controler
 * @version v1.0.5
 * @copyright Tussendoor internet & marketing
 */
function accordionControler(e) {
    e.preventDefault();

    var btn = e.target,
        parent = e.target.parentNode,
        awnser = parent.querySelector('.js--faq__inner');

    if (awnser.getAttribute('aria-hidden') === 'true') {
        awnser.setAttribute('aria-hidden', 'false');
        btn.setAttribute('aria-expanded', 'true');
        parent.classList.add('open');
    } else {
        awnser.setAttribute('aria-hidden', 'true');
        btn.setAttribute('aria-expanded', 'false');
        parent.classList.remove('open');
    }

    var url = [location.protocol, '//', location.host, location.pathname].join('');
    history.pushState({}, '', url);
}